module.exports = __webpack_public_path__ + "static/media/mediaHtml.1d18d819.png";